var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "shopping-bag_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 6 3-4h12l3 4v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6ZM3 6h18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10a4 4 0 1 1-8 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgShoppingBag as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMyA2TDYgMkgxOEwyMSA2VjIwQzIxIDIwLjUzMDQgMjAuNzg5MyAyMS4wMzkxIDIwLjQxNDIgMjEuNDE0MkMyMC4wMzkxIDIxLjc4OTMgMTkuNTMwNCAyMiAxOSAyMkg1QzQuNDY5NTcgMjIgMy45NjA4NiAyMS43ODkzIDMuNTg1NzkgMjEuNDE0MkMzLjIxMDcxIDIxLjAzOTEgMyAyMC41MzA0IDMgMjBWNloiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0zIDZIMjEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0xNiAxMEMxNiAxMS4wNjA5IDE1LjU3ODYgMTIuMDc4MyAxNC44Mjg0IDEyLjgyODRDMTQuMDc4MyAxMy41Nzg2IDEzLjA2MDkgMTQgMTIgMTRDMTAuOTM5MSAxNCA5LjkyMTcyIDEzLjU3ODYgOS4xNzE1NyAxMi44Mjg0QzguNDIxNDMgMTIuMDc4MyA4IDExLjA2MDkgOCAxMCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";